export const ShieldStrikethroughIcon: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M13.5534 10.9126L12.3883 9.70874C12.5437 9.2945 12.6667 8.86408 12.7573 8.41748C12.8479 7.97087 12.8932 7.52104 12.8932 7.06796V3.39806L8.23301 1.65049L5.39806 2.71845L4.19417 1.51456L8.23301 0L14.4466 2.3301V7.06796C14.4466 7.72816 14.3722 8.38188 14.2233 9.02913C14.0744 9.67638 13.8511 10.3042 13.5534 10.9126ZM14.2913 16L11.767 13.4757C11.2751 13.9806 10.7282 14.4045 10.1262 14.7476C9.52427 15.0906 8.8932 15.3528 8.23301 15.534C6.43366 15.0809 4.94822 14.0485 3.7767 12.4369C2.60518 10.8252 2.01942 9.0356 2.01942 7.06796V3.72816L0 1.70874L1.08738 0.621359L15.3786 14.9126L14.2913 16ZM8.23301 13.9029C8.68608 13.7605 9.11974 13.5599 9.53398 13.301C9.94822 13.0421 10.3301 12.7379 10.6796 12.3883L3.57282 5.28155V7.06796C3.57282 8.6343 4.01294 10.0583 4.8932 11.3398C5.77346 12.6214 6.88673 13.4757 8.23301 13.9029Z" />
    </svg>
  );
};
